<template>
  <div class="video-container">
    <br>
    <br>
    <br>
    <video style="height: 700px; width: 100%; object-fit: cover;" src="@/assets/default/videoinsegt.mp4" autoplay muted loop class="responsive-video"></video>
    <br>
    <div class="center" :class="!$vuetify.breakpoint.smAndDown ? 'textLogo-container' : null">
      <h1 class="center" :style="{ color: $ajustes.colorTexto2 }"
        style="font-size: 90pt; font-weight: bold; line-height: 80px;">{{$ajustes.textoLogoCorto }}</h1>
      <h1 class="center" :style="{ color: $ajustes.colorTexto2 }"
        style="font-size: 20pt; font-weight: bold; line-height: 30px;" v-html="$textoFormateado($ajustes.textoLogoLargo)"></h1>
    </div>
<br>
    <div class="center" :class="!$vuetify.breakpoint.smAndDown ? 'textSlogan-container' : null">
      <h1 class="center" :style="{ color: $ajustes.colorTexto2 }"
        style="font-size: 30pt; font-weight: bold; line-height: 50px;" v-html="$textoFormateado($ajustes.textoLogoSlogan)"></h1>
      <div class="arrow" style="margin-top: -20px; animation-delay: 0.2s;">▼</div>
    </div>

    <!-- Flechas ▼ animadas y estiradas -->
    <div v-if="!$vuetify.breakpoint.smAndDown" class="arrow-container">
      <div :style="{ color: $ajustes.colorTexto2 }" class="arrow">▼</div>
      <div :style="{ color: $ajustes.colorTexto2 }" class="arrow" style="animation-delay: 0.2s;">▼</div>
      <div :style="{ color: $ajustes.colorTexto2 }" class="arrow" style="animation-delay: 0.4s;">▼</div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
      colorCabecera: "",

    };
  },
  mounted() {
  },
  created() {
  },
  methods: {
  },
  computed: {
    textoLogoLargoFormateado() {
      return this.$ajustes.textoLogoLargo && typeof this.$ajustes.textoLogoLargo === 'string'
        ? this.$ajustes.textoLogoLargo.replace(/\*/g, '<br>')
        : '';
    },
    textoLogoSloganFormateado() {
      return this.$ajustes.textoLogoSlogan && typeof this.$ajustes.textoLogoSlogan === 'string'
        ? this.$ajustes.textoLogoSlogan.replace(/\*/g, '<br>')
        : '';
    }
  },
  beforeDestroy() {
  },
};
</script>
<style scoped>
.video-container {
  position: relative;
  width: 100%;
  margin: 0 auto;
}

.responsive-video {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 8px;
}

.textLogo-container {
  position: absolute;
  bottom: 50%;
  right: 1%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
}

.textSlogan-container {
  position: absolute;
  bottom: 45%;
  left: 1%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
}

.arrow-container {
  position: absolute;
  bottom: 10%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
}

.arrow {
  font-size: 45px;
  color: #11476b;
  display: inline-block;
  transform: scaleX(2.5);
  /* estira horizontalmente */
  animation: bounce 1.5s infinite;
  opacity: 0.8;
}

@keyframes bounce {

  0%,
  80%,
  100% {
    transform: scaleX(2.5) translateY(0);
  }

  40% {
    transform: scaleX(2.5) translateY(10px);
  }
}
</style>
